function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M51,35.5c0-1.93-1.57-3.5-3.5-3.5h-31c-1.93,0-3.5,1.57-3.5,3.5s1.57,3.5,3.5,3.5h2.374c-0.445,1.724-2.013,3-3.874,3  c-3.309,0-6,2.691-6,6v8c0,3.309,2.691,6,6,6h34c3.309,0,6-2.689,6-5.996l0-8.148c0-1.564-0.609-3.035-1.715-4.141  C52.179,42.608,50.708,42,49.143,42h-0.125c-1.869,0-3.444-1.276-3.891-3H47.5C49.43,39,51,37.43,51,35.5z M44,37.002  c-0.552,0-1,0.448-1,1C43,41.31,45.699,44,49.017,44h0.125c1.031,0,2,0.401,2.729,1.129C52.6,45.857,53,46.825,53,47.855l0,8.148  C53,58.207,51.206,60,49,60H15c-2.206,0-4-1.794-4-4v-8c0-2.206,1.794-4,4-4c3.309,0,6-2.691,6-6c0-0.553-0.448-1-1-1h-3.5  c-0.827,0-1.5-0.673-1.5-1.5s0.673-1.5,1.5-1.5h31c0.827,0,1.5,0.673,1.5,1.5S48.327,37,47.5,37L44,37.002z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M52,2c-5.177,0-9.446,3.954-9.949,9H40c-2.757,0-5,2.243-5,5v10.586l-1.293-1.293l-1.414,1.414l3,3  C35.488,29.902,35.744,30,36,30s0.512-0.098,0.707-0.293l3-3l-1.414-1.414L37,26.586V16c0-1.654,1.346-3,3-3h2.051  c0.503,5.046,4.773,9,9.949,9c5.514,0,10-4.486,10-10S57.514,2,52,2z M52,20c-4.411,0-8-3.589-8-8s3.589-8,8-8s8,3.589,8,8  S56.411,20,52,20z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M2,21c0,3.859,3.14,7,7,7c3.519,0,6.432-2.614,6.92-6H17c1.654,0,3,1.346,3,3v1.586l-1.293-1.293l-1.414,1.414l3,3  C20.488,29.902,20.744,30,21,30s0.512-0.098,0.707-0.293l3-3l-1.414-1.414L22,26.586V25c0-2.757-2.243-5-5-5h-1.08  c-0.488-3.386-3.401-6-6.92-6C5.14,14,2,17.141,2,21z M14,21c0,2.757-2.243,5-5,5s-5-2.243-5-5s2.243-5,5-5S14,18.243,14,21z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M26.935,8.094C26.488,4.662,23.552,2,20,2c-3.86,0-7,3.141-7,7s3.14,7,7,7c3.467,0,6.345-2.536,6.897-5.848  C28.111,10.536,29,11.66,29,13v4.586l-1.293-1.293l-1.414,1.414l3,3C29.488,20.902,29.744,21,30,21s0.512-0.098,0.707-0.293l3-3  l-1.414-1.414L31,17.586V13C31,10.563,29.245,8.534,26.935,8.094z M20,14c-2.757,0-5-2.243-5-5s2.243-5,5-5s5,2.243,5,5  S22.757,14,20,14z"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 46.343,
  y: 11,
  transform: "matrix(0.7071 -0.7071 0.7071 0.7071 6.7452 40.2843)",
  width: 11.314,
  height: 2
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 54,
  y: 13,
  width: 2,
  height: 2
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 48,
  y: 9,
  width: 2,
  height: 2
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M20,48c-2.757,0-5,2.243-5,5s2.243,5,5,5s5-2.243,5-5S22.757,48,20,48z M20,56c-1.654,0-3-1.346-3-3s1.346-3,3-3  s3,1.346,3,3S21.654,56,20,56z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M32,48c-2.757,0-5,2.243-5,5s2.243,5,5,5s5-2.243,5-5S34.757,48,32,48z M32,56c-1.654,0-3-1.346-3-3s1.346-3,3-3  s3,1.346,3,3S33.654,56,32,56z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M39,53c0,2.757,2.243,5,5,5s5-2.243,5-5s-2.243-5-5-5S39,50.243,39,53z M44,50c1.654,0,3,1.346,3,3s-1.346,3-3,3  s-3-1.346-3-3S42.346,50,44,50z"
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  x: 27,
  y: 37,
  width: 2,
  height: 2
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  x: 31,
  y: 37,
  width: 2,
  height: 2
});

var _ref14 = /*#__PURE__*/React.createElement("rect", {
  x: 35,
  y: 37,
  width: 2,
  height: 2
});

var SvgSaving = function SvgSaving(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 80",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSaving, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/saving.5085e859.svg";
export { ForwardRef as ReactComponent };